export default "__VITE_ASSET__D9g1aTZR__"